import { Outlet } from "@remix-run/react";
import Footer from "../components/Footer";

export default function SearchRoute() {
  return (
    <div className="flex flex-col min-h-screen">
      <Outlet />
      <Footer />
    </div>
  );
}
